(() => {
  const drawer = document.querySelector('#CartDrawer.cart-drawer--evergreen');
  if (!drawer || drawer.dataset.evergreenReady) return;
  drawer.dataset.evergreenReady = 'true';

  const recommendations = drawer.querySelector('[data-cart-evergreen-recommendations]');
  const upsell = recommendations?.querySelector('[data-upsell-block]');
  const rail = drawer.querySelector('[data-cart-evergreen-offer-rail]');
  const desktop = window.matchMedia('(min-width: 990px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let scheduled = false;
  let transfer = null;
  const catalog = new Map();

  function shortTitle(value) {
    const parts = value.split('|').map(part => part.trim().replace(/^Dalstrong\s+[©®]?\s*/i, '').replace(/\s*[©®]\s*$/, '')).filter(part => part && !/^dalstrong$/i.test(part));
    if (parts.length > 1 && /\b(series|edition|collection)\b/i.test(parts[0])) parts.push(parts.shift());
    const name = parts.find(part => !/\b(series|edition|collection)\b/i.test(part)) || parts[0];
    const size = parts.find(part => part !== name && /\b(size|small|medium|large)\b/i.test(part));
    return [name, size].filter(Boolean).join(' · ') || value;
  }

  function showExclusive(offer, price) {
    if (offer.querySelector('[data-cart-evergreen-exclusive]')) return;
    const label = document.createElement('span');
    label.className = 'cart-evergreen__exclusive';
    label.setAttribute('data-cart-evergreen-exclusive', '');
    label.textContent = recommendations.dataset.exclusiveLabel;
    price.closest('[data-essential-upsell-element="price"]')?.after(label);
  }

  function prepareOffer(offer) {
    const title = offer.querySelector('[data-essential-upsell-element="title"]');
    if (title) {
      const full = title.dataset.cartFullTitle && title.textContent === shortTitle(title.dataset.cartFullTitle)
        ? title.dataset.cartFullTitle : title.textContent.trim();
      title.dataset.cartFullTitle = full;
      const label = shortTitle(full);
      if (title.textContent !== label) title.textContent = label;
      if (title.getAttribute('aria-label') !== full) title.setAttribute('aria-label', full);
      const series = full.split('|').map(part => part.trim()).find(part => /\b(series|edition|collection)\b/i.test(part));
      let eyebrow = offer.querySelector('[data-cart-evergreen-offer-series]');
      if (series) {
        if (!eyebrow) {
          eyebrow = document.createElement('span');
          eyebrow.className = 'cart-evergreen__offer-series';
          eyebrow.setAttribute('data-cart-evergreen-offer-series', '');
          title.before(eyebrow);
        }
        if (eyebrow.textContent !== series) eyebrow.textContent = series;
      } else eyebrow?.remove();
    }

    // A compare-at price alone is not a cart-exclusive discount. Check the app's
    // exact variant against its current, locale-aware catalog price (GET only).
    const price = offer.querySelector('[data-discounted-price-value][data-variant-id]');
    const badge = offer.querySelector('[data-cart-evergreen-exclusive]');
    const href = title?.getAttribute('href');
    if (!price || !href || !drawer.classList.contains('open')) {
      badge?.remove();
      return;
    }
    let link;
    try { link = new URL(href, window.location.origin); } catch { badge?.remove(); return; }
    const handle = link.pathname.match(/\/products\/([^/]+)\/?$/)?.[1];
    if (link.origin !== window.location.origin || !handle) { badge?.remove(); return; }
    const productUrl = new URL(`${recommendations.dataset.catalogRoot || '/'}products/${handle}.js`, window.location.origin);
    const key = productUrl.href;
    if (!catalog.has(key)) {
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 5000);
      catalog.set(key, fetch(key, { credentials: 'same-origin', signal: controller.signal })
        .then(response => response.ok ? response.json() : null).catch(() => null)
        .finally(() => window.clearTimeout(timeout)));
    }
    const signature = `${key}:${price.dataset.variantId}:${price.dataset.discountedPriceValue}`;
    if (offer.dataset.cartPriceCheck === signature) {
      if (offer.dataset.cartVerifiedExclusive === 'true') showExclusive(offer, price);
      return;
    }
    offer.dataset.cartPriceCheck = signature;
    offer.dataset.cartVerifiedExclusive = 'false';
    badge?.remove();
    catalog.get(key).then(product => {
      if (!offer.isConnected || !offer.contains(price) || offer.dataset.cartPriceCheck !== signature) return;
      const variant = product?.variants?.find(item => String(item.id) === price.dataset.variantId);
      const amount = price.dataset.discountedPriceValue;
      const cents = /^\d+(\.\d+)?$/.test(amount) ? Math.round(Number(amount) * 100) : NaN;
      if (!variant?.available || !Number.isFinite(variant.price) || !Number.isFinite(cents) || cents < 0 || cents >= variant.price || !recommendations.dataset.exclusiveLabel) return;
      offer.dataset.cartVerifiedExclusive = 'true';
      showExclusive(offer, price);
    });
  }

  function offerId(offer) {
    return offer.querySelector('[data-product-id]')?.dataset.productId;
  }

  function visibleRect(element) {
    if (!element || !element.getClientRects().length) return null;
    const rect = element.getBoundingClientRect();
    return rect.width && rect.height ? rect : null;
  }

  function positions() {
    const result = new Map();
    drawer.querySelectorAll('.cart__item[data-key]').forEach(element => {
      const rect = visibleRect(element);
      if (rect) result.set(`cart:${element.dataset.key}`, { element, rect });
    });
    upsell?.querySelectorAll('[data-essential-upsell-element="product"]').forEach(element => {
      const id = offerId(element);
      const rect = visibleRect(element);
      if (id && rect) result.set(`offer:${id}`, { element, rect });
    });
    return result;
  }

  function prepareList() {
    let hasOffer = false;
    const seen = new Set();
    const upgradeProducts = new Set([...drawer.querySelectorAll('[data-cart-pdp-upgrades]:not([hidden]) [data-cart-pdp-upgrade-products]')].flatMap(card=>(card.dataset.cartPdpUpgradeProducts || '').split(',').filter(Boolean)));
    upsell.querySelectorAll('[data-essential-upsell-element="products"]').forEach(products => {
      const section = products.closest('section[aria-label]');
      if (!section || section === recommendations) return;
      const label = recommendations.getAttribute('aria-label');
      if (label && section.getAttribute('aria-label') !== label) section.setAttribute('aria-label', label);
      const help = products.previousElementSibling;
      if (help && !help.hasAttribute('data-essential-upsell-element')) {
        help.setAttribute('data-cart-evergreen-carousel-help', '');
        if (help.getAttribute('aria-hidden') !== 'true') help.setAttribute('aria-hidden', 'true');
      }
    });
    upsell.querySelectorAll('[data-essential-upsell-element="product"]').forEach(offer => {
      const slide = offer.closest('[role="group"]') || offer;
      const identity = offerId(offer) || offer.querySelector('a[href]')?.getAttribute('href');
      const variant = offer.querySelector('[data-variant-id]')?.getAttribute('data-variant-id') || '';
      const key = `${identity}:${variant}`;
      const duplicate = Boolean(identity && (seen.has(key) || upgradeProducts.has(identity)));
      if (identity) seen.add(key);
      slide.toggleAttribute('data-cart-evergreen-duplicate', duplicate);
      const actionable = Boolean(identity);
      const excluded = slide.hasAttribute('data-cart-upsell-excluded');
      slide.toggleAttribute('data-cart-evergreen-placeholder', !actionable);
      if (!actionable || excluded || duplicate) return;
      hasOffer = true;
      prepareOffer(offer);
      if (slide.hasAttribute('aria-hidden')) slide.removeAttribute('aria-hidden');
      const title = offer.querySelector('[data-essential-upsell-element="title"]')?.textContent.trim();
      if (title && slide.getAttribute('aria-label') !== title) slide.setAttribute('aria-label', title);
      offer.querySelectorAll('a[tabindex="-1"], button[tabindex="-1"], select[tabindex="-1"], input[tabindex="-1"]').forEach(control => control.removeAttribute('tabindex'));
    });
    return hasOffer;
  }

  function animateTransfer() {
    if (!transfer) return;
    if (Date.now() > transfer.expires) {
      transfer = null;
      return;
    }
    const inCart = Array.from(drawer.querySelectorAll('[data-cart-product-id]')).some(element => element.dataset.cartProductId === transfer.id);
    if ((transfer.kind === 'add') !== inCart) return;
    const target = transfer.kind === 'add'
      ? Array.from(drawer.querySelectorAll('.cart__item[data-cart-product-id]')).find(element => element.dataset.cartProductId === transfer.id)
      : Array.from(upsell.querySelectorAll('[data-essential-upsell-element="product"]')).find(element => offerId(element) === transfer.id);
    if (!visibleRect(target)) return;
    const previous = transfer;
    transfer = null;
    if (reducedMotion.matches || !drawer.classList.contains('open') || typeof target.animate !== 'function') return;
    const options = { duration: 260, easing: 'cubic-bezier(.2,.7,.2,1)' };
    positions().forEach(({ element, rect }, key) => {
      const before = previous.positions.get(key)?.rect;
      if (!before || element === target) return;
      const x = before.left - rect.left;
      const y = before.top - rect.top;
      if (Math.abs(x) > 1 || Math.abs(y) > 1) element.animate([{ transform: `translate(${x}px, ${y}px)` }, { transform: 'none' }], options);
    });
    target.animate([{ transform: 'translateY(10px)', opacity: 0.45 }, { transform: 'none', opacity: 1 }], options);
    const image = target.querySelector('.cart__image img, [data-essential-upsell-element="image"]');
    const rect = visibleRect(image);
    if (rect && previous.from) image.animate([
      { transform: `translate(${previous.from.left - rect.left}px, ${previous.from.top - rect.top}px) scale(.9)` },
      { transform: 'none' }
    ], options);
  }

  function syncPresentation() {
    const count = drawer.querySelector('[data-cart-body]')?.dataset.cartItemCount || '0';
    const countLabel = drawer.querySelector('[data-cart-evergreen-count]');
    if (countLabel && countLabel.textContent !== count) countLabel.textContent = count;

    if (recommendations && upsell) {
      // Keep the app's manual portal and all of its ancestors stationary.
      // The app treats DOM moves as removal and destroys its portal; CSS alone
      // switches between the desktop rail and the inline mobile layout.
      if (typeof window.filterCartUpsells === 'function') window.filterCartUpsells();
      const hasOffer = prepareList();
      const hasUpgrade = Boolean(recommendations.querySelector('[data-cart-pdp-upgrades]:not([hidden]) [data-cart-pdp-upgrade]'));
      const hasAppOffer = upsell.dataset.upsellVisible !== 'false' && !upsell.hasAttribute('data-cart-upsell-empty') && hasOffer;
      recommendations.hidden = count === '0' || (!hasAppOffer && !hasUpgrade);
    }

    if (rail) {
      const hasPromo = Boolean(rail.querySelector('[data-promo-offer-panel] .promo-panel'));
      const hasRecommendations = recommendations && !recommendations.hidden;
      rail.hidden = !hasRecommendations && (!desktop.matches || !hasPromo);
    }
    animateTransfer();
  }

  function schedulePresentation() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      syncPresentation();
    });
  }

  if (upsell) {
    new MutationObserver(schedulePresentation).observe(drawer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'href', 'data-upsell-visible', 'data-cart-upsell-empty', 'data-cart-upsell-excluded', 'data-product-id', 'data-variant-id', 'data-discounted-price-value', 'aria-hidden', 'tabindex']
    });
  }
  drawer.addEventListener('click', event => {
    const add = event.target.closest('[data-essential-upsell-element="add-to-cart-button"]');
    const remove = event.target.closest('[data-remove-item]');
    const minus = event.target.closest('.js-qty__adjust--minus');
    const lastUnit = minus && Number(minus.closest('.js-qty__wrapper')?.querySelector('input')?.value) === 1;
    const cartAction = remove || (lastUnit ? minus : null);
    const source = add?.closest('[data-essential-upsell-element="product"]') || cartAction?.closest('.cart__item');
    if (!source || add?.disabled) return;
    const id = add ? offerId(source) : source.dataset.cartProductId;
    if (!id) return;
    transfer = {
      kind: add ? 'add' : 'remove',
      id,
      from: visibleRect(source.querySelector('.cart__image img, [data-essential-upsell-element="image"]') || source),
      positions: positions(),
      expires: Date.now() + 10000
    };
  }, true);
  desktop.addEventListener('change', () => {
    transfer = null;
    schedulePresentation();
  });
  document.addEventListener('cart:drawer:refreshed', schedulePresentation);
  document.addEventListener('cart:pdp-upgrades:updated', schedulePresentation);
  syncPresentation();
})();
